import apiClient from './client'
import { plannerApiUrl } from '@/config/api'
import {
  DreamityPlanMasterResDto,
  DreamityPlanMasterSaveReqDto,
  DreamityPlanMasterModifyReqDto,
  DreamityItemMasterResDto,
  DreamityItemMasterSaveReqDto,
  DreamityItemMasterModifyReqDto,
} from '@/store/types/master.types'

/**
 * Dreamity Master API
 * 명세서 기반 구현
 */
export const masterApi = {
  /**
   * 플랜 마스터 전체 조회
   * GET /api/dreamity/master/plan/all
   * 등록된 모든 플랜 마스터 목록 조회
   */
  fetchPlanMasters: async (): Promise<DreamityPlanMasterResDto[]> => {
    const response = await apiClient.get(plannerApiUrl('master/plan/all'))
    return response.data
  },

  /**
   * 플랜 마스터 단건 조회
   * GET /api/dreamity/master/plan/detail/{id}
   * 특정 플랜 마스터 정보 조회
   */
  fetchPlanMasterById: async (id: number): Promise<DreamityPlanMasterResDto> => {
    const response = await apiClient.get(plannerApiUrl(`master/plan/detail/${id}`))
    return response.data
  },

  /**
   * 플랜 마스터 생성
   * POST /api/dreamity/master/plan
   * 플랜 마스터 신규 등록
   * Response: 204 No Content
   */
  createPlanMaster: async (
    planMaster: DreamityPlanMasterSaveReqDto
  ): Promise<void> => {
    await apiClient.post(plannerApiUrl('master/plan'), planMaster)
  },

  /**
   * 플랜 마스터 수정
   * PUT /api/dreamity/master/plan/{id}
   * 플랜 마스터 정보 수정
   * Response: 204 No Content
   */
  updatePlanMaster: async (
    id: number,
    planMaster: DreamityPlanMasterModifyReqDto
  ): Promise<void> => {
    await apiClient.put(plannerApiUrl(`master/plan/${id}`), planMaster)
  },

  /**
   * 플랜 마스터 삭제
   * DELETE /api/dreamity/master/plan/{id}
   * 플랜 마스터 삭제
   * Response: 204 No Content
   */
  deletePlanMaster: async (id: number): Promise<void> => {
    await apiClient.delete(plannerApiUrl(`master/plan/${id}`))
  },

  /**
   * 아이템 마스터 전체 조회
   * GET /api/dreamity/master/item/all
   * 등록된 모든 아이템 마스터 목록 조회
   */
  fetchItemMasters: async (): Promise<DreamityItemMasterResDto[]> => {
    const response = await apiClient.get(plannerApiUrl('master/item/all'))
    return response.data
  },

  /**
   * 아이템 마스터 단건 조회
   * GET /api/dreamity/master/item/detail/{id}
   * 특정 아이템 마스터 조회
   */
  fetchItemMasterById: async (
    id: number
  ): Promise<DreamityItemMasterResDto> => {
    const response = await apiClient.get(plannerApiUrl(`master/item/detail/${id}`))
    return response.data
  },

  /**
   * 아이템 마스터 생성
   * POST /api/dreamity/master/item
   * 아이템 마스터 신규 등록
   * Response: 204 No Content
   */
  createItemMaster: async (
    itemMaster: DreamityItemMasterSaveReqDto
  ): Promise<void> => {
    await apiClient.post(plannerApiUrl('master/item'), itemMaster)
  },

  /**
   * 아이템 마스터 수정
   * PUT /api/dreamity/master/item/{id}
   * 아이템 마스터 정보 수정
   * Response: 204 No Content
   */
  updateItemMaster: async (
    id: number,
    itemMaster: DreamityItemMasterModifyReqDto
  ): Promise<void> => {
    await apiClient.put(plannerApiUrl(`master/item/${id}`), itemMaster)
  },

  /**
   * 아이템 마스터 삭제
   * DELETE /api/dreamity/master/item/{id}
   * 아이템 마스터 삭제
   * Response: 204 No Content
   */
  deleteItemMaster: async (id: number): Promise<void> => {
    await apiClient.delete(plannerApiUrl(`master/item/${id}`))
  },
}

